const Tabs = {
  baseStyle: {},
  variants: {
    mini: {
      tab: {
        fontSize: "sm",
        px: 3,
        py: 1,
        fontWeight: 500,
        color: "Gray.500",
        _selected: {
          color: "Primary.500",
          borderColor: "Primary.500",
          borderBottomWidth: "2px",
          borderBottomStyle: "solid",
        },
      },
      tablist: {
        borderBottomWidth: "1px",
        borderColor: "Gray.200",
      },
    },
    base: {
      root: {
        margin: 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0,
        py: 0,
        px: [4, 4, 8],
      },
      tabpanels: {
        borderStyle: "solid",
        borderColor: "Gray.300",
        borderWidth: "1px 0 0 0",
        p: 0,
        flexGrow: 1,
        minHeight: 0,
      },
      tabpanel: {
        height: "100%",
        pt: [1, 1, 2],
        pr: 0,
        pb: 0,
        pl: 0,
        overflow: "visible",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0,
      },
      tab: {
        mr: 4,
        h: 10,
        pt: 3,
        pb: 1.5,
        px: 0,
        display: "flex",
        alignItems: "flex-end",
        flexShrink: 0,
        fontSize: "xs",
        fontWeight: "semibold",
        textTransform: "uppercase",
        letterSpacing: "wider",
        color: "Gray.500",
        bg: "Gray.100",
        borderStyle: "none",
        textDecoration: "none",
        _hover: {
          color: "Gray.800",
          textDecoration: "none",
          borderStyle: "solid",
          borderColor: "Primary.300",
          borderWidth: "0 0 2px 0",
          _disabled: {
            textDecoration: "none",
          },
        },
        _disabled: {
          color: "Gray.300",
        },
        _selected: {
          color: "Gray.900",
          borderStyle: "solid",
          borderColor: "Primary.500",
          borderWidth: "0 0 2px 0",
        },
      },
    },
  },
}

export default Tabs
